import { render, staticRenderFns } from "./MitManageBorrowedPage.vue?vue&type=template&id=67d81a56&scoped=true"
import script from "./MitManageBorrowedPage.vue?vue&type=script&lang=js"
export * from "./MitManageBorrowedPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageBorrowedPage.vue?vue&type=style&index=0&id=67d81a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d81a56",
  null
  
)

export default component.exports